import {
  isInspectorActive,
  useDataInspectorStore,
} from './data-inspector.store';
import styles from './data-inspector-indicator.module.css';
import { trackDataInspectorUsed } from './data-inspector-tracking';

/**
 * Standing reminder that Data Inspector mode is on, and the way back into the
 * drawer once it has been closed. Hidden entirely when the mode is off.
 */
export const DataInspectorIndicator = () => {
  const enabled = useDataInspectorStore(isInspectorActive);
  const isOpen = useDataInspectorStore((state) => state.isOpen);
  // Capture runs with the mode off too, so read the count only when it is
  // actually on screen — otherwise every request in the session re-renders a
  // component that returns null.
  const recordCount = useDataInspectorStore((state) =>
    isInspectorActive(state) ? state.records.length : 0
  );
  const setOpen = useDataInspectorStore((state) => state.setOpen);

  if (!enabled || isOpen) return null;

  return (
    <button
      type="button"
      className={styles.indicator}
      onClick={() => {
        trackDataInspectorUsed('opened_from_indicator');
        setOpen(true);
      }}
      data-testid="data-inspector-indicator"
    >
      <span className={styles.dot} />
      Data Inspector
      <span className={styles.count}>{recordCount}</span>
    </button>
  );
};
